/**
 * Development environment configuration
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://dev-presentation.everycred.com/api/v1'
};
